import {
  BookMarked,
  BookOpen,
  Calendar,
  ChevronLeft,
  ChevronRight,
  DollarSign,
  DollarSignIcon,
  Group,
  LayoutDashboard,
  ListTodo,
  LogOut,
  Projector,
  ScanBarcode,
  Settings,
  Tags,
  User2,
  UserCheck2,
  Users2,
} from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "../ui/sidebar";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../ui/collapsible";
import { useLanguage } from "../../context/LanguageContext";
import { SidebarData } from "../../lib/languages";
import { useAuth } from "../../context/AuthContext";

const LogoSideBar = ({ logoName }) => (
  <SidebarMenu>
    <SidebarMenuItem>
      <SidebarMenuButton
        size="lg"
        className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
      >
        <Link to={"/"} className="flex items-center gap-2">
          <div className="flex aspect-square size-8 items-center justify-center rounded-lg  text-sidebar-primary-foreground">
            {/* <BookOpen className="size-4" /> */}
            <img
              src="/Artboard.png"
              alt="LOGO"
              className="object-cover w-8 h-8"
            />
          </div>
          <span className="truncate font-semibold">{logoName}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  </SidebarMenu>
);

export function AppSidebarUser() {
  const { language } = useLanguage();
  const { user, loading } = useAuth();

  return (
    <Sidebar
      variant={"floating"}
      collapsible={"icon"}
      side={language === "ar" ? "right" : "left"}
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      <SidebarHeader>
        <LogoSideBar logoName={"فريق أساكيب"} />
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <MenuItemComponent
                Icon={UserCheck2}
                url={"/"}
                title={"الحضور و الانصراف"}
              />
              {/* User -update & -delete */}
              <MenuItemComponent
                Icon={Projector}
                url={"/projects"}
                title={"المشاريع"}
              />
              <MenuItemComponent
                Icon={ListTodo}
                url={"/tasks"}
                title={"المهام"}
              />
              {!loading && user?.role === "admin" && (
                <>
                  <MenuItemComponent
                    Icon={Users2}
                    url={"/users"}
                    title={"المستخدمون"}
                  />
                  <MenuItemComponent
                    Icon={Tags}
                    url={"/categories"}
                    title={"الأقسام"}
                  />
                  <MenuItemComponent
                    Icon={Group}
                    url={"/teams"}
                    title={"المجموعات"}
                  />
                  <MenuItemComponent
                    Icon={DollarSignIcon}
                    url={"/salaries"}
                    title={"الرواتب"}
                  />
                  <MenuItemComponent
                    Icon={ScanBarcode}
                    url={"/transactions"}
                    title={"المعاملات المالية"}
                  />
                </>
              )}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      {/* 
      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              tooltip={"Logout"}
              className="bg-blue-600 text-white transition-colors hover:bg-blue-600/80 hover:text-white h-10"
            >
              <Link to={"/"}>
                <LogOut />
                <span>{"Logout"}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter> */}
    </Sidebar>
  );
}

const MenuItemComponent = ({ title, url, Icon }) => (
  <SidebarMenuItem>
    <SidebarMenuButton asChild tooltip={title}>
      <NavLink to={url}>
        <Icon />
        <span>{title}</span>
      </NavLink>
    </SidebarMenuButton>
  </SidebarMenuItem>
);

const CollapsComponent = ({ Icon, title, items }) => {
  const { language } = useLanguage();
  const ArrowIcon = language === "ar" ? ChevronLeft : ChevronRight;

  return (
    <Collapsible asChild className="group/collapsible">
      <SidebarMenuItem>
        <CollapsibleTrigger asChild>
          <SidebarMenuButton tooltip={title}>
            {Icon && <Icon />}
            <span>{title}</span>
            <ArrowIcon
              className={`${
                language === "ar"
                  ? "mr-auto group-data-[state=open]/collapsible:-rotate-90"
                  : "ml-auto group-data-[state=open]/collapsible:rotate-90"
              } transition-transform duration-200`}
            />
          </SidebarMenuButton>
        </CollapsibleTrigger>

        <CollapsibleContent>
          <SidebarMenuSub>
            {items.map((item) => (
              <SidebarMenuSubItem key={item.title} tooltip={item.title}>
                <SidebarMenuSubButton asChild>
                  <Link to={item.url}>
                    <span>{item.title}</span>
                  </Link>
                </SidebarMenuSubButton>
              </SidebarMenuSubItem>
            ))}
          </SidebarMenuSub>
        </CollapsibleContent>
      </SidebarMenuItem>
    </Collapsible>
  );
};
